import React from "react";
import holdHand from "../utils/images/holdHand.jpg";
import meghwalIcon from "../utils/images/appIcons/meghwalIcon.webp";
import paliwalIcon from "../utils/images/appIcons/paliwalIcon.webp";
const AppDownload = () => {

    const platforms = [
        { name: "मेघवाल एकीकरण", link: "https://play.google.com/store/apps/details?id=com.meghwalsamaj&pcampaignid=web_share", icon: meghwalIcon },
        { name: "पालीवाल ब्राह्मण समाज", link: "https://play.google.com/store/apps/details?id=com.paliwalkutumb&pcampaignid=web_share", icon: paliwalIcon },
    ];

    return (
        <div className="flex flex-col md:flex-row items-center bg-white p-10 rounded-lg shadow-lg max-w-6xl mx-auto mt-5">
            {/* Image Section */}
            <div className="flex-shrink-0 mb-6 md:mb-0 md:mr-12">
                <img
                    src={holdHand}
                    alt="App Illustration"
                    className="w-80 h-80 rounded-full shadow-md object-cover"
                />
            </div>

            {/* Content Section */}
            <div className="text-center md:text-left">
                {/* <h2 className="text-2xl font-bold text-blue-900 mb-4">ऐप डाउनलोड करें</h2>
                <p className="text-gray-700 text-lg">
                    “मेरा समाज” ऐप्प समाज को डिजिटल मंच प्रदान करता हैं तथ समाज की सूचनाये
                    अखिल भारतीय / राज्य/तहसील / ग्राम स्तर पर प्रत्येक समाज बंधू तक साझा
                    कर सकते हैं। <br />
                    ऐप्प के माध्यम से प्रतेक समाज बंधू का समाज व सामाजिक कार्यो से जुडाव /
                    सीधा सम्पर्क। <br />
                    वंशावली का चित्रण द्वारा रिश्तो को पहचान हुई आसान।
                </p> */}
                {/* Download Links Section */}
                <div className="mt-6">
                    <h3 className="text-lg font-semibold text-blue-900">
                        प्लैटफ़ॉर्म को प्रयोग में लेने वाले समाज:
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {platforms.map((platform, index) => (
                            <div
                                key={index}
                                className="flex items-center gap-4 bg-gray-50 rounded-md shadow p-4"
                            >
                                {/* Icon */}
                                <img
                                    src={platform.icon}
                                    alt={`${platform.name} Icon`}
                                    className="w-12 h-12 rounded-full shadow-md object-cover"
                                />
                                <div>
                                    {/* Society Name */}
                                    <p className="text-gray-800 font-semibold mb-2">{platform.name}</p>
                                    {/* Download Button */}
                                    <a
                                        href={platform.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="bg-blue-500 text-white text-sm px-4 py-2 rounded-md shadow hover:bg-blue-600 transition-colors"
                                    >
                                        डाउनलोड करें
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppDownload;
